// The standalone home page has no React app, so mount the same footer
// language switcher the other pages use (it swaps the footer's EN / FR chip
// for the multi-language dropdown and drives the shared TranslationManager).
import React from 'react'
import { createRoot } from 'react-dom/client'
import FooterLanguageSwitcher from './FooterLanguageSwitcher.jsx'

const host = document.createElement('div')
host.id = 'pb-home-lang'
document.body.appendChild(host)
createRoot(host).render(<FooterLanguageSwitcher />)
